import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// SweetAlert2 for confirmation dialogs
import Swal from "sweetalert2";

import { getAllScanPermissionsApi, deleteScanPermissionApi } from "api/scan";

function VoirScans() {
  const navigate = useNavigate();
  const [scans, setScans] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchScans = async () => {
    try {
      setIsLoading(true);
      const response = await getAllScanPermissionsApi();
      if (response.success) {
        setScans(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch scans:", error);
      Swal.fire("err", "err   .", "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchScans();
  }, []);

  const handleDelete = (scanId) => {
    Swal.fire({
      title: "Êtes-vous sûr ?",
      text: "Vous ne pourrez pas annuler cette action !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimer !",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteScanPermissionApi(scanId);
          Swal.fire("Supprimé !", "L'enregistrement a été supprimé avec succès.", "success");
          fetchScans(); // Recharger les données après la suppression
        } catch (error) {
          Swal.fire("Erreur !", "Une erreur s'est produite lors de la suppression.", "error");
          console.error("Delete error:", error);
        }
      }
    });
  };

  const columns = [
    { Header: "Revendeur", accessor: (row) => row.fromReseller?.email || "N/A" },
    { Header: "Événement", accessor: (row) => row.selectedEvents?.eventTitle || "N/A" },
    {
      Header: "Statut",
      accessor: "canScan",
      Cell: ({ value }) => (
        <MDBadge
          badgeContent={value ? "Activé" : "Désactivé"}
          color={value ? "success" : "secondary"}
          variant="gradient"
          size="sm"
        />
      ),
    },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <MDBox>
          <MDButton
            variant="text"
            color="info"
            onClick={() => navigate(`/scans/modifier/${row.original._id}`)}
          >
            Modifier
          </MDButton>
          <MDButton variant="text" color="error" onClick={() => handleDelete(row.original._id)}>
            Supprimer
          </MDButton>
        </MDBox>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  (Scans)
                </MDTypography>
                <MDButton
                  variant="gradient"
                  color="dark"
                  onClick={() => navigate("/scans/ajouter")}
                >
                  ajouter
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows: scans }}
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                  isLoading={isLoading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default VoirScans;
